export default __webpack_public_path__ + "static/media/order_management_transporters.5c476997.png";